// @ts-nocheck
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
// import { getData, postData } from "../../Axios/axiosData";

const initialState = {
  PersonlListWithPayrol: [],
  AssignmentActionList: [],
  RunResultList: [],
  loading: false,
  error: null,
  //~~
  PayrollActionList: [],
  loadingActionList: false,
  errorActionList: null,
  //~~
  PeriodTimeList: [],
  loadingPeriodTimeList: false,
  errorPeriodTimeList: null,
  //~~
  PersonListByPayroll: [],
  loading2: false,
  error2: null
};

export const ActinRunPyroll = createAsyncThunk(
  'RunPyroll/ActinRunPyroll',
  async (item, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    console.log(JSON.stringify(item));
    debugger;

    try {
      // const data = await postData('Payroll/RunPayroll' , item);
      const { data } = await ntxAPI.post('Payroll/RunPayroll', item);
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

//  const { data } = await ntxAPI.get(`Payroll/GetPeriodTimeByPayrollId?PayrollId=${id}`); //  تجيب المتبقي
export const GetPeriodTimeByPayrollId = createAsyncThunk(
  'RunPyroll/GetPeriodTimeByPayrollId',
  async ({ PayrollId, AssignmentId }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    const url = AssignmentId
      ? `Payroll/GetPeriodTimeList?PayrollId=${PayrollId}&AssignmentId=${AssignmentId}`
      : `Payroll/GetPeriodTimeList?PayrollId=${PayrollId}`;
    try {
      // Payroll/GetPeriodTimeList?PayrollId=a7f1962c-01d0-4bcf-adc3-4f3e2db9153f&AssignmentId=a7f1962c-01d0-4bcf-adc3-4f3e2db9153f
      // Payroll/GetPeriodTimeList?PayrollId=a7f1962c-01d0-4bcf-adc3-4f3e2db9153f
      const { data } = await ntxAPI.get(url); // تجيب الكل
      // const { data } = await ntxAPI.get(`Payroll/GetPeriodTimeList?PayrollId=${id}`); // تجيب الكل
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const GetPersonlListWithPayrol = createAsyncThunk(
  'RunPyroll/GetPersonlListWithPayrol',
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      // const data = await getData(`Payroll/GetPersonlListWithPayrol`);
      const { data } = await ntxAPI.get(`Payroll/GetPersonlListWithPayrol`);
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const GetPayrollActionList = createAsyncThunk(
  'RunPyroll/GetPayrollActionList',
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      // const data = await getData(`Payroll/GetPayrollActionListByPayrollId?PayrollId=${id}`);
      const { data } = await ntxAPI.get(`Payroll/GetPayrollActionListByPayrollId?PayrollId=${id}`);
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const GetAssignmentActionList = createAsyncThunk(
  'RunPyroll/GetAssignmentActionList',
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      // const data = await getData(`Payroll/GetAssignmentActionListByPayrollActionId?PayrollActionId=${id}`);
      const { data } = await ntxAPI.get(
        `Payroll/GetAssignmentActionListByPayrollActionId?PayrollActionId=${id}`
      );
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getPersonListPayrollToRun = createAsyncThunk(
  'RunPyroll/getPersonListPayrollToRun',
  async ({ PeriodId, PayrollId }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(
        `Payroll/GetPersonListPayrollToRun?PeriodId=${PeriodId}&PayrollId=${PayrollId}`
      );
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const GetRunResultList = createAsyncThunk(
  'RunPyroll/GetRunResultList',
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      // const data = await getData(`Payroll/GetRunResultListByAssignmentActionId?AssignmentActionId=${id}`);
      const { data } = await ntxAPI.get(
        `Payroll/GetRunResultListByAssignmentActionId?AssignmentActionId=${id}`
      );
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const DeletePayrollAction = createAsyncThunk(
  'RunPyroll/DeletePayrollAction',
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.post(`Payroll/DeletePayrollAction?PayrollActionId=${id}`);
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const ConfirmPayrollAction = createAsyncThunk(
  'RunPyroll/ConfirmPayrollAction',
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.post(`Payroll/ConfirmPayrollAction?PayrollActionId=${id}`);
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const sendPayrollActionToAme = createAsyncThunk(
  'RunPyroll/sendPayrollActionToAme',
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.post(`Payroll/SendPayrollActionToAme?PayrollActionId=${id}`);
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createAccountPayroll = createAsyncThunk(
  'RunPyroll/createAccount',
  async (item, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.post(`Payroll/CreateAccount`, item);
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

const RunPayrollSlice = createSlice({
  name: 'RunPyroll',
  initialState,
  reducers: {
    cleanUpPayrollActionList: state => {
      state.PayrollActionList = [];
    },
    cleanUpPersonListByPayroll: state => {
      state.PersonListByPayroll = [];
    },
    cleanUpPeriodTimeList: state => {
      state.PeriodTimeList = [];
    }
  },
  extraReducers(builder) {
    builder
      /////// get GetPeriodTimeByPayrollId
      .addCase(GetPeriodTimeByPayrollId.pending, state => {
        state.loadingPeriodTimeList = true;
        state.errorPeriodTimeList = null;
        state.PeriodTimeList = [];
      })
      .addCase(GetPeriodTimeByPayrollId.fulfilled, (state, action) => {
        state.loadingPeriodTimeList = false;
        state.PeriodTimeList = action.payload.data;
      })
      .addCase(GetPeriodTimeByPayrollId.rejected, (state, action) => {
        state.loadingPeriodTimeList = false;
        state.errorPeriodTimeList = action.payload;
      })

      /////// GetPersonlListWithPayrol
      .addCase(GetPersonlListWithPayrol.pending, state => {
        state.loading = true;
        state.error = null;
        state.PersonlListWithPayrol = [];
      })
      .addCase(GetPersonlListWithPayrol.fulfilled, (state, action) => {
        state.loading = false;
        state.PersonlListWithPayrol = action.payload;
      })
      .addCase(GetPersonlListWithPayrol.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /////// Get Payroll Action List
      .addCase(GetPayrollActionList.pending, state => {
        state.loadingActionList = true;
        state.errorActionList = null;
        state.PayrollActionList = [];
      })
      .addCase(GetPayrollActionList.fulfilled, (state, action) => {
        state.loadingActionList = false;
        state.PayrollActionList = action.payload;
      })
      .addCase(GetPayrollActionList.rejected, (state, action) => {
        state.loadingActionList = false;
        state.errorActionList = action.payload;
      })

      /////// Get Assignment Action List
      .addCase(GetAssignmentActionList.pending, state => {
        state.loading = true;
        state.error = null;
        state.AssignmentActionList = [];
      })
      .addCase(GetAssignmentActionList.fulfilled, (state, action) => {
        state.loading = false;
        state.AssignmentActionList = action.payload;
      })
      .addCase(GetAssignmentActionList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /////// Get Run Result List
      .addCase(GetRunResultList.pending, state => {
        state.loading = true;
        state.error = null;
        state.RunResultList = [];
      })
      .addCase(GetRunResultList.fulfilled, (state, action) => {
        state.loading = false;
        state.RunResultList = action.payload;
      })
      .addCase(GetRunResultList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /////// get Person List By Payroll
      .addCase(getPersonListPayrollToRun.pending, state => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(getPersonListPayrollToRun.fulfilled, (state, action) => {
        state.loading2 = false;
        state.PersonListByPayroll = action.payload;
      })
      .addCase(getPersonListPayrollToRun.rejected, (state, action) => {
        state.loading2 = false;
        state.error2 = action.payload;
      });
  }
});

export const { cleanUpPayrollActionList, cleanUpPersonListByPayroll, cleanUpPeriodTimeList } =
  RunPayrollSlice.actions;
export default RunPayrollSlice.reducer;
